import { Controller } from '@hotwired/stimulus';

// Controller for calendar date/time selection
// Used in booking process step 2 (date/time selection)
// Receives availability data from server and renders time slots dynamically
export default class extends Controller {
  static targets = ['timeSlotsWrapper', 'timeSlots', 'timeSlotsList', 'dateInput'];
  static values = {
    availability: { type: Array, default: [] }
  };

  connect() {
    this.selectedDate = null;
    this.availabilityMap = this.buildAvailabilityMap();

    // Event delegation for dynamically added time slot radio buttons
    this.element.addEventListener('change', (e) => this.handleTimeChange(e));
  }

  handleTimeChange(event) {
    const radio = event.target;
    if (radio.type === 'radio' && radio.name.includes('[time]')) {
      this.selectTime({ currentTarget: radio });
    }
  }

  // Build a map of date -> times for quick lookup
  buildAvailabilityMap() {
    const map = {};
    this.availabilityValue.forEach((day) => {
      map[day.date] = day.times;
    });
    return map;
  }

  selectDate(event) {
    const button = event.currentTarget;
    const date = button.dataset.date;

    if (!date || button.disabled) return;

    // Deselect all other dates
    this.element.querySelectorAll('.calendar__cell-button').forEach((btn) => {
      btn.setAttribute('aria-selected', 'false');
      btn.classList.remove('selected');
    });

    // Select this date
    button.setAttribute('aria-selected', 'true');
    button.classList.add('selected');
    this.selectedDate = date;

    // Update hidden input
    if (this.hasDateInputTarget) {
      this.dateInputTarget.value = date;
    }

    // Only render time slots dynamically if we have availability data
    // Otherwise, the static time slots from the server are already rendered
    if (this.availabilityValue.length > 0) {
      this.renderTimeSlots(date);
    }

    // Show time slots panel
    if (this.hasTimeSlotsTarget) {
      this.timeSlotsTarget.classList.remove('hidden');
    }
  }

  renderTimeSlots(date) {
    if (!this.hasTimeSlotsListTarget) return;

    const times = this.availabilityMap[date] || [];

    if (times.length === 0) {
      this.timeSlotsListTarget.innerHTML =
        '<p class="text-gray-500">Keine Zeiten verfügbar</p>';
      return;
    }

    const html = times
      .map(
        (time) => `
      <div class="booking-radio">
        <label class="booking-radio__inner booking-radio__inner--no-content">
          <input type="radio"
                 name="form[time]"
                 value="${time}"
                 data-action="change->booking-calendar#selectTime">
          <span class="booking-radio__label">${time}</span>
        </label>
      </div>
    `
      )
      .join('');

    this.timeSlotsListTarget.innerHTML = html;
  }

  selectTime(event) {
    const radio = event.currentTarget;
    const time = radio.value;

    // Combine date and time into starts_at
    if (this.selectedDate && time) {
      // Search in the whole form, not just controller element
      const form = this.element.closest('form');
      const startsAtInput =
        form?.querySelector('input[name*="starts_at"]') ||
        this.element.querySelector('input[name*="starts_at"]');

      if (startsAtInput) {
        startsAtInput.value = `${this.selectedDate} ${time}`;
      }
    }
  }
}
